module.exports = __webpack_public_path__ + "img/corn_salsa.86d094fb.jpg";